import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

interface GuestRouteProps {
  children?: React.ReactNode;
}

const GuestRoute: React.FC<GuestRouteProps> = ({ children }) => {
  const isReduxUser = useSelector((state: RootState) => state.user.isUser);
  const token = localStorage.getItem("token");

  const isAuthenticated = Boolean(token || isReduxUser);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default GuestRoute;
